import moment from 'moment';

export function formatDate(timeStamp?: number) {
  if (!timeStamp) {
    return '--';
  }

  return moment(timeStamp).format('MMM D, YYYY, h:mm A');
}
